import client, { axiosToDjangoParamsSerializer } from './axios'

const scanApi = {
  getScans: (parameters) => {
    return client.get('data/scan/list', {
      params: parameters,
      paramsSerializer: axiosToDjangoParamsSerializer,
    })
  },

  export: (selectedRows, filters) => {
    return client.get('data/scan/export/csv', {
      params: {
        ids__in: selectedRows,
        ...filters,
      },
      paramsSerializer: axiosToDjangoParamsSerializer,
      responseType: 'blob',
    })
  },

  filters: () => {
    return client.get('data/scan/filters')
  },
}

export default scanApi
